var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _line, _rect8, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInjection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#eff6ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 50,
    width: 70,
    height: 165,
    rx: 10,
    fill: "white",
    stroke: "#3b82f6",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 80,
    width: 40,
    height: 8,
    rx: 2,
    fill: "#dbeafe"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 98,
    width: 40,
    height: 8,
    rx: 2,
    fill: "#dbeafe"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 116,
    width: 40,
    height: 8,
    rx: 2,
    fill: "#dbeafe"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 134,
    width: 40,
    height: 8,
    rx: 2,
    fill: "#dbeafe"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 215,
    width: 20,
    height: 25,
    rx: 3,
    fill: "#3b82f6",
    opacity: 0.35
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 240,
    x2: 200,
    y2: 252,
    stroke: "#3b82f6",
    strokeWidth: 2,
    opacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 38,
    width: 24,
    height: 16,
    rx: 4,
    fill: "#3b82f6",
    opacity: 0.25
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 280,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#1e40af"
  }, "Enjeksiyon")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjection);
export default __webpack_public_path__ + "static/media/injection.2a1f1162bbc563fadc0a62a82e7f1083.svg";
export { ForwardRef as ReactComponent };